import { RemotingModule_createApi, RemotingModule_withRouteBuilder, Remoting_buildProxy_Z15584635 } from "../../fable_modules/Fable.Remoting.Client.7.19.0/Remoting.fs.js";
import { Metadata_CategoryMenuOption$reflection, Metadata_SortInfo$reflection, SearchResultInfo$reflection, GeoMapConfig$reflection, MetadataDistribution, MetadataDistribution$reflection, FreqListTokenBoundaries, FreqListTokenBoundaries$reflection, SearchResult$reflection, Metadata_Category$reflection, DownloadFormat$reflection, MediaObject$reflection, MediaPlayerType$reflection, SearchParams_Init_Z7AD2BBF3, SearchParams$reflection, Cwb_PositionalAttribute$reflection, IServerApi$reflection, Route_builder } from "../../Shared/Shared.js";
import { Union, Record } from "../../fable_modules/fable-library.3.7.9/Types.js";
import { bool_type, class_type, union_type, int32_type, list_type, record_type, option_type, array_type, tuple_type, string_type } from "../../fable_modules/fable-library.3.7.9/Reflection.js";
import { defaultArg } from "../../fable_modules/fable-library.3.7.9/Option.js";
import { empty } from "../../fable_modules/fable-library.3.7.9/List.js";
import { empty as empty_1 } from "../../fable_modules/fable-library.3.7.9/Map.js";
import { empty as empty_2 } from "../../fable_modules/fable-library.3.7.9/Set.js";
import { comparePrimitives } from "../../fable_modules/fable-library.3.7.9/Util.js";
import { fromInteger, toNumber } from "../../fable_modules/fable-library.3.7.9/Long.js";

export const serverApi = Remoting_buildProxy_Z15584635(RemotingModule_withRouteBuilder(Route_builder, RemotingModule_createApi()), {
    ResolveType: IServerApi$reflection,
});

export class LoadingCorpusModel extends Record {
    constructor(MaybeCorpusList) {
        super();
        this.MaybeCorpusList = MaybeCorpusList;
    }
}

export function LoadingCorpusModel$reflection() {
    return record_type("Model.LoadingCorpusModel", [], LoadingCorpusModel, () => [["MaybeCorpusList", option_type(array_type(tuple_type(string_type, string_type)))]]);
}

export class CwbAttributeMenuModule_AttributeSection extends Record {
    constructor(Heading, SubcategoryHeading, Values) {
        super();
        this.Heading = Heading;
        this.SubcategoryHeading = SubcategoryHeading;
        this.Values = Values;
    }
}

export function CwbAttributeMenuModule_AttributeSection$reflection() {
    return record_type("Model.CwbAttributeMenuModule.AttributeSection", [], CwbAttributeMenuModule_AttributeSection, () => [["Heading", string_type], ["SubcategoryHeading", string_type], ["Values", list_type(tuple_type(Cwb_PositionalAttribute$reflection(), string_type, string_type, list_type(tuple_type(string_type, list_type(tuple_type(Cwb_PositionalAttribute$reflection(), string_type, string_type))))))]]);
}

export class AttributeModalModel extends Record {
    constructor(QueryIndex, TermIndex, IncludeExcludeInput) {
        super();
        this.QueryIndex = (QueryIndex | 0);
        this.TermIndex = (TermIndex | 0);
        this.IncludeExcludeInput = IncludeExcludeInput;
    }
}

export function AttributeModalModel$reflection() {
    return record_type("Model.AttributeModalModel", [], AttributeModalModel, () => [["QueryIndex", int32_type], ["TermIndex", int32_type], ["IncludeExcludeInput", string_type]]);
}

export function AttributeModalModel_Init_Z37302880(queryIndex, termIndex) {
    return new AttributeModalModel(queryIndex, termIndex, "");
}

export class ListOrIntervalMode extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["ListMode", "IntervalMode"];
    }
}

export function ListOrIntervalMode$reflection() {
    return union_type("Model.ListOrIntervalMode", [], ListOrIntervalMode, () => [[], []]);
}

export class SearchInterface extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Simple", "Extended", "Cqp"];
    }
}

export function SearchInterface$reflection() {
    return union_type("Model.SearchInterface", [], SearchInterface, () => [[], [["Item", option_type(AttributeModalModel$reflection())]], []]);
}

export class Search extends Record {
    constructor(Interface, Params) {
        super();
        this.Interface = Interface;
        this.Params = Params;
    }
}

export function Search$reflection() {
    return record_type("Model.Search", [], Search, () => [["Interface", SearchInterface$reflection()], ["Params", SearchParams$reflection()]]);
}

export function Search_Init_Z7AD2BBF3(corpusConfig) {
    return new Search(new SearchInterface(0), SearchParams_Init_Z7AD2BBF3(corpusConfig));
}

export class Corpus {
    constructor(sharedInfo, cwbAttributeMenu, metadataMenu, metadataTable, metadataQuickView, metadataDistributionCategories) {
        this["SharedInfo@"] = sharedInfo;
        this["CwbAttributeMenu@"] = cwbAttributeMenu;
        this["MetadataMenu@"] = defaultArg(metadataMenu, empty());
        this["MetadataTable@"] = defaultArg(metadataTable, empty());
        this["MetadataQuickView@"] = defaultArg(metadataQuickView, empty());
        this["MetadataDistributionCategories@"] = defaultArg(metadataDistributionCategories, empty());
    }
    ["Model.Corpus.ResultLinksZ731E88D3"](_arg1, _arg2, _arg3, _arg4, _arg5) {
        return null;
    }
    ["Model.Corpus.SelectionTableFirstColumnZ3081B86A"](_arg6, _arg7) {
        return null;
    }
}

export function Corpus$reflection() {
    return class_type("Model.Corpus", void 0, Corpus);
}

export function Corpus_$ctor_64685318(sharedInfo, cwbAttributeMenu, metadataMenu, metadataTable, metadataQuickView, metadataDistributionCategories) {
    return new Corpus(sharedInfo, cwbAttributeMenu, metadataMenu, metadataTable, metadataQuickView, metadataDistributionCategories);
}

export function Corpus__get_SharedInfo(__) {
    return __["SharedInfo@"];
}

export function Corpus__get_CwbAttributeMenu(__) {
    return __["CwbAttributeMenu@"];
}

export function Corpus__get_MetadataMenu(__) {
    return __["MetadataMenu@"];
}

export function Corpus__get_MetadataTable(__) {
    return __["MetadataTable@"];
}

export function Corpus__get_MetadataQuickView(__) {
    return __["MetadataQuickView@"];
}

export function Corpus__get_MetadataDistributionCategories(__) {
    return __["MetadataDistributionCategories@"];
}

export class MediaPlayerInfo extends Record {
    constructor(Type, RowIndex, MediaObject) {
        super();
        this.Type = Type;
        this.RowIndex = (RowIndex | 0);
        this.MediaObject = MediaObject;
    }
}

export function MediaPlayerInfo$reflection() {
    return record_type("Model.MediaPlayerInfo", [], MediaPlayerInfo, () => [["Type", MediaPlayerType$reflection()], ["RowIndex", int32_type], ["MediaObject", MediaObject$reflection()]]);
}

export class SyntaxNode extends Record {
    constructor(index, ort, pos, dep, fun, match) {
        super();
        this.index = (index | 0);
        this.ort = ort;
        this.pos = pos;
        this.dep = (dep | 0);
        this.fun = fun;
        this.match = match;
    }
}

export function SyntaxNode$reflection() {
    return record_type("Model.SyntaxNode", [], SyntaxNode, () => [["index", int32_type], ["ort", string_type], ["pos", string_type], ["dep", int32_type], ["fun", string_type], ["match", bool_type]]);
}

export class ConcordanceModel extends Record {
    constructor(ContextSizeTextValue, IsSearching, ShouldShowDownloadWindow, DownloadingFormat, HeadersInDownload, DownloadAttributes, DownLoadCategories, NumResults, NumSteps, PagesBeingFetched, PaginatorPageNo, PaginatorTextValue, ResultPageNo, ResultPages, MediaPlayer, VideoContextSize, VideoContextUnit, Translations, VisibleSyntaxTreeKeys) {
        super();
        this.ContextSizeTextValue = ContextSizeTextValue;
        this.IsSearching = IsSearching;
        this.ShouldShowDownloadWindow = ShouldShowDownloadWindow;
        this.DownloadingFormat = DownloadingFormat;
        this.HeadersInDownload = HeadersInDownload;
        this.DownloadAttributes = DownloadAttributes;
        this.DownLoadCategories = DownLoadCategories;
        this.NumResults = NumResults;
        this.NumSteps = (NumSteps | 0);
        this.PagesBeingFetched = PagesBeingFetched;
        this.PaginatorPageNo = (PaginatorPageNo | 0);
        this.PaginatorTextValue = PaginatorTextValue;
        this.ResultPageNo = (ResultPageNo | 0);
        this.ResultPages = ResultPages;
        this.MediaPlayer = MediaPlayer;
        this.VideoContextSize = (VideoContextSize | 0);
        this.VideoContextUnit = VideoContextUnit;
        this.Translations = Translations;
        this.VisibleSyntaxTreeKeys = VisibleSyntaxTreeKeys;
    }
}

export function ConcordanceModel$reflection() {
    return record_type("Model.ConcordanceModel", [], ConcordanceModel, () => [["ContextSizeTextValue", string_type], ["IsSearching", bool_type], ["ShouldShowDownloadWindow", bool_type], ["DownloadingFormat", option_type(DownloadFormat$reflection())], ["HeadersInDownload", bool_type], ["DownloadAttributes", list_type(Cwb_PositionalAttribute$reflection())], ["DownLoadCategories", list_type(Metadata_Category$reflection())], ["NumResults", option_type(class_type("System.Int64"))], ["NumSteps", int32_type], ["PagesBeingFetched", array_type(int32_type)], ["PaginatorPageNo", int32_type], ["PaginatorTextValue", string_type], ["ResultPageNo", int32_type], ["ResultPages", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, array_type(SearchResult$reflection())])], ["MediaPlayer", option_type(MediaPlayerInfo$reflection())], ["VideoContextSize", int32_type], ["VideoContextUnit", string_type], ["Translations", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, string_type])], ["VisibleSyntaxTreeKeys", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])]]);
}

export function ConcordanceModel_Init_Z176EF219(numSteps, contextSizeTextValue) {
    return new ConcordanceModel(contextSizeTextValue, true, false, void 0, true, empty(), empty(), void 0, numSteps, new Int32Array([]), 1, "1", 1, empty_1(), void 0, 25, "who_start", empty_1(), empty_2({
        Compare: comparePrimitives,
    }));
}

export function ConcordanceModel__NumResultPages_Z524259A4(this$, pageSize) {
    let value;
    const matchValue = this$.NumResults;
    if (matchValue == null) {
        return 0;
    }
    else {
        return (~(~((value = (toNumber(matchValue) / pageSize), Math.ceil(value))))) | 0;
    }
}

export class FrequencyListItem extends Record {
    constructor(Frequency, AttributeValues) {
        super();
        this.Frequency = Frequency;
        this.AttributeValues = AttributeValues;
    }
}

export function FrequencyListItem$reflection() {
    return record_type("Model.FrequencyListItem", [], FrequencyListItem, () => [["Frequency", class_type("System.Int64")], ["AttributeValues", array_type(string_type)]]);
}

export class FrequencyListsModel extends Record {
    constructor(Attributes, Frequencies, IsCaseSensitive, IsFetchingFrequencyList, TokenBoundaries, DownloadingFormat) {
        super();
        this.Attributes = Attributes;
        this.Frequencies = Frequencies;
        this.IsCaseSensitive = IsCaseSensitive;
        this.IsFetchingFrequencyList = IsFetchingFrequencyList;
        this.TokenBoundaries = TokenBoundaries;
        this.DownloadingFormat = DownloadingFormat;
    }
}

export function FrequencyListsModel$reflection() {
    return record_type("Model.FrequencyListsModel", [], FrequencyListsModel, () => [["Attributes", list_type(Cwb_PositionalAttribute$reflection())], ["Frequencies", option_type(array_type(FrequencyListItem$reflection()))], ["IsCaseSensitive", bool_type], ["IsFetchingFrequencyList", bool_type], ["TokenBoundaries", FreqListTokenBoundaries$reflection()], ["DownloadingFormat", option_type(DownloadFormat$reflection())]]);
}

export function FrequencyListsModel_get_Default() {
    return new FrequencyListsModel(empty(), void 0, false, false, new FreqListTokenBoundaries(void 0, void 0), void 0);
}

export class ExcludedAttributeValues extends Record {
    constructor(Accumulated, New) {
        super();
        this.Accumulated = Accumulated;
        this.New = New;
    }
}

export function ExcludedAttributeValues$reflection() {
    return record_type("Model.ExcludedAttributeValues", [], ExcludedAttributeValues, () => [["Accumulated", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])], ["New", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])]]);
}

export class MetadataDistributionModel extends Record {
    constructor(SelectedAttributeCode, SelectedCategory, MetadataDistribution, KeepZeroValues, ExcludedAttributeValues, IsFetching, DownloadingFormat) {
        super();
        this.SelectedAttributeCode = SelectedAttributeCode;
        this.SelectedCategory = SelectedCategory;
        this.MetadataDistribution = MetadataDistribution;
        this.KeepZeroValues = KeepZeroValues;
        this.ExcludedAttributeValues = ExcludedAttributeValues;
        this.IsFetching = IsFetching;
        this.DownloadingFormat = DownloadingFormat;
    }
}

export function MetadataDistributionModel$reflection() {
    return record_type("Model.MetadataDistributionModel", [], MetadataDistributionModel, () => [["SelectedAttributeCode", option_type(string_type)], ["SelectedCategory", option_type(Metadata_Category$reflection())], ["MetadataDistribution", MetadataDistribution$reflection()], ["KeepZeroValues", bool_type], ["ExcludedAttributeValues", ExcludedAttributeValues$reflection()], ["IsFetching", bool_type], ["DownloadingFormat", option_type(DownloadFormat$reflection())]]);
}

export function MetadataDistributionModel_Init() {
    return new MetadataDistributionModel(void 0, void 0, new MetadataDistribution([], empty(), fromInteger(0, false, 2), 0), true, new ExcludedAttributeValues(empty_2({
        Compare: comparePrimitives,
    }), empty_2({
        Compare: comparePrimitives,
    })), false, void 0);
}

export class ResultTab extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Concordance", "GeoDistributionMap", "FrequencyLists", "MetadataDistribution"];
    }
}

export function ResultTab$reflection() {
    return union_type("Model.ResultTab", [], ResultTab, () => [[], [["Item1", GeoMapConfig$reflection()], ["Item2", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, class_type("System.Int64")])])]], [["Item", FrequencyListsModel$reflection()]], [["Item", MetadataDistributionModel$reflection()]]]);
}

export class ShowingResultsModel extends Record {
    constructor(ActiveTab, SearchResults, NumSteps, ConcordanceModel) {
        super();
        this.ActiveTab = ActiveTab;
        this.SearchResults = SearchResults;
        this.NumSteps = (NumSteps | 0);
        this.ConcordanceModel = ConcordanceModel;
    }
}

export function ShowingResultsModel$reflection() {
    return record_type("Model.ShowingResultsModel", [], ShowingResultsModel, () => [["ActiveTab", ResultTab$reflection()], ["SearchResults", option_type(SearchResultInfo$reflection())], ["NumSteps", int32_type], ["ConcordanceModel", ConcordanceModel$reflection()]]);
}

export function ShowingResultsModel_Init_Z176EF219(numSteps, contextSizeTextValue) {
    return new ShowingResultsModel(new ResultTab(0), void 0, numSteps, ConcordanceModel_Init_Z176EF219(numSteps, contextSizeTextValue));
}

export class LoadedCorpusSubstate extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["CorpusStart", "ShowingResults"];
    }
}

export function LoadedCorpusSubstate$reflection() {
    return union_type("Model.LoadedCorpusSubstate", [], LoadedCorpusSubstate, () => [[], [["Item", ShowingResultsModel$reflection()]]]);
}

export class LoadedCorpusModel extends Record {
    constructor(Corpus, FetchedMetadataValues, FetchedMinAndMax, FetchedTextMetadata, GeoDistribution, IsMetadataGeoMapOpen, IsNarrowWindow, IsSelectionTableOpen, IntervalCategoryModes, NumSelectedTexts, NumSelectedTokens, OpenMetadataCategoryCode, Search, ShouldShowMetadataMenu, ShouldShowQuickView, SelectionTablePageNumber, SelectionTableSort, Substate, TextSelectionInfo, TextIdInQuickView, QuickViewMetadata) {
        super();
        this.Corpus = Corpus;
        this.FetchedMetadataValues = FetchedMetadataValues;
        this.FetchedMinAndMax = FetchedMinAndMax;
        this.FetchedTextMetadata = FetchedTextMetadata;
        this.GeoDistribution = GeoDistribution;
        this.IsMetadataGeoMapOpen = IsMetadataGeoMapOpen;
        this.IsNarrowWindow = IsNarrowWindow;
        this.IsSelectionTableOpen = IsSelectionTableOpen;
        this.IntervalCategoryModes = IntervalCategoryModes;
        this.NumSelectedTexts = NumSelectedTexts;
        this.NumSelectedTokens = NumSelectedTokens;
        this.OpenMetadataCategoryCode = OpenMetadataCategoryCode;
        this.Search = Search;
        this.ShouldShowMetadataMenu = ShouldShowMetadataMenu;
        this.ShouldShowQuickView = ShouldShowQuickView;
        this.SelectionTablePageNumber = (SelectionTablePageNumber | 0);
        this.SelectionTableSort = SelectionTableSort;
        this.Substate = Substate;
        this.TextSelectionInfo = TextSelectionInfo;
        this.TextIdInQuickView = TextIdInQuickView;
        this.QuickViewMetadata = QuickViewMetadata;
    }
}

export function LoadedCorpusModel$reflection() {
    return record_type("Model.LoadedCorpusModel", [], LoadedCorpusModel, () => [["Corpus", Corpus$reflection()], ["FetchedMetadataValues", array_type(string_type)], ["FetchedMinAndMax", option_type(tuple_type(class_type("System.Int64"), class_type("System.Int64")))], ["FetchedTextMetadata", array_type(array_type(string_type))], ["GeoDistribution", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, class_type("System.Int64")])])], ["IsMetadataGeoMapOpen", bool_type], ["IsNarrowWindow", bool_type], ["IsSelectionTableOpen", bool_type], ["IntervalCategoryModes", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, ListOrIntervalMode$reflection()])], ["NumSelectedTexts", option_type(class_type("System.Int64"))], ["NumSelectedTokens", option_type(class_type("System.Int64"))], ["OpenMetadataCategoryCode", option_type(string_type)], ["Search", Search$reflection()], ["ShouldShowMetadataMenu", option_type(bool_type)], ["ShouldShowQuickView", bool_type], ["SelectionTablePageNumber", int32_type], ["SelectionTableSort", option_type(Metadata_SortInfo$reflection())], ["Substate", LoadedCorpusSubstate$reflection()], ["TextSelectionInfo", string_type], ["TextIdInQuickView", option_type(string_type)], ["QuickViewMetadata", list_type(Metadata_CategoryMenuOption$reflection())]]);
}

export class Model extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["LoadingCorpus", "LoadedCorpus"];
    }
}

export function Model$reflection() {
    return union_type("Model.Model", [], Model, () => [[["Item", LoadingCorpusModel$reflection()]], [["Item", LoadedCorpusModel$reflection()]]]);
}

